module.exports = __webpack_public_path__ + "static/open-road--mobile-389aa189a297c01184cf66f824e5b672.jpg";